import { t } from 'i18next';

import { DriverTypeahead } from '~hooks/useDrivers/models';

import OptionCodePair from './OptionCodePair';

export default function DriverOptionSecondary({
  companyId,
  driver,
  query,
}: {
  companyId: string;
  driver: DriverTypeahead | null | undefined;
  query: string;
}) {
  const driverCompany = driver?.company;

  if (!driverCompany || driverCompany.id === companyId) {
    return null;
  }

  return (
    <OptionCodePair
      label={t('form_fields.company')}
      query={query}
      value={driverCompany.legalName}
    />
  );
}
